import artifact from '$houdini/artifacts/UpdateSalesOrderBasicFields'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateSalesOrderBasicFieldsStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
